import { IconButton } from '@mui/material';
import useFavoritos from '@/hooks/useFavoritos';
import FavoritosIcon from '../icons/favoritos-icon';

const FavoriteToggleButton = ({ playerId, size = 20, sx = {} }) => {
    const { favoritos, agregarFavorito, eliminarFavorito } = useFavoritos();

    // Verificar si el jugador es favorito
    const isPlayerFavorite = favoritos.some((fav) => fav.id === String(playerId));

    // Manejar toggle de favoritos
    const handleToggleFavorite = async (e) => {
        e.stopPropagation(); // Evitar que se propague el evento

        try {
            if (isPlayerFavorite) {
                await eliminarFavorito({ id: String(playerId), type: 'player' });
            } else {
                // Necesitamos el nombre del jugador, pero por ahora usamos un placeholder
                await agregarFavorito({ id: String(playerId), type: 'player', name: `Player ${playerId}` });
            }
        } catch (error) {
            console.error('Error al actualizar favoritos:', error);
        }
    };

    // Si no hay playerId, no mostrar nada
    if (!playerId) return null;

    return (
        <IconButton
            onClick={handleToggleFavorite}
            size="small"
            sx={sx}
            aria-label={isPlayerFavorite ? 'Quitar de favoritos' : 'Agregar a favoritos'}
        >
            <FavoritosIcon
                width={size}
                height={size}
                fillColor={isPlayerFavorite ? '#ff0000' : 'transparent'}
                strokeColor={isPlayerFavorite ? '#ff0000' : '#ccc'}
            />
        </IconButton>
    );
};

export default FavoriteToggleButton;
